module.exports = __webpack_public_path__ + "static/media/ind.037548b5.svg";